import { render, staticRenderFns } from "./c_comb_data.vue?vue&type=template&id=0fabc054&scoped=true"
import script from "./c_comb_data.vue?vue&type=script&lang=js"
export * from "./c_comb_data.vue?vue&type=script&lang=js"
import style0 from "./c_comb_data.vue?vue&type=style&index=0&id=0fabc054&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fabc054",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/yunxiao/be-3sdnltdmmjqei95chipgpfz5/runner/__flow_work/__flow_builds/182a3969-2a32-4dff-94d8-cf1bbedf203a/workspace/crmeb-mer-admin_BNnv/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fabc054')) {
      api.createRecord('0fabc054', component.options)
    } else {
      api.reload('0fabc054', component.options)
    }
    module.hot.accept("./c_comb_data.vue?vue&type=template&id=0fabc054&scoped=true", function () {
      api.rerender('0fabc054', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/maintain/components/mobileConfigRight/c_comb_data.vue"
export default component.exports